export function rgbToRgba(rgbString: string, opacity: number): string {
  // if opacity is outside of [0,1] throw error
  if (!(opacity >= 0 && opacity <= 1)) {
    throw new Error(
      `call of rgbToRbga with opacity = ${opacity}, outside of Interval [0,1]`,
    );
  }

  const colorString: string[] = rgbString.split(",");
  try {
    const r: string = colorString[0].split("(")[1];
    const g: string = colorString[1];
    const b: string = colorString[2].split(")")[0];
    return `rgba(${r},${g},${b},${opacity})`;
  } catch {
    throw new Error(
      `call of rgbToRbga with string ${rgbString} not correct form of "rgb(r,g,b)"`,
    );
  }
}

export function formatTime(time: string) {
  const timeComp = time.split(":");
  if (timeComp[0].length === 1) {
    timeComp[0] = "0" + timeComp[0];
  } else {
    return time;
  }
  return `${timeComp[0]}:${timeComp[1]}:${timeComp[2]}`;
}
